/* ts:disable */
var noop = function noop() {};

export default noop;